export default "__VITE_ASSET__689e5f08__"